// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import AddressAutocompleteController from './address_autocomplete_controller';
import AddProfileController from './add_profile_controller.js';
import AutoCloseCollapseController from './auto_close_collapse.js';
import ClearDocumentFileController from './clear_document_file_controller.js';
import ConditionalCheckboxesController from './conditional_checkboxes_controller.js';
import DocumentTypeTabsController from './document_type_tabs_controller.js';
import DragDropController from './drag_drop_controller.js';
import EffectiveBeneficiariesController from './effective_beneficiaries_controller.js';
import IntlTelInputController from './intl_tel_input_controller.js';
import LimitedNestedFormController from './limited_nested_form_controller.js';
import ModalController from './modal_controller.js';
import PappersAutocompleteController from './pappers_autocomplete_controller.js';
import PasswordVisibilityController from './password_visibility_controller.js';
import ProfileStepsPreviewController from './profile_steps_preview_controller.js';
import RailsNestedForm from '@stimulus-components/rails-nested-form'
import StartImportController from './start_import_controller.js';
import TabSwitcherController from './tab_switcher_controller.js';
import TablePaginationController from './table_pagination_controller.js';
import TableTooltipController from './table_tooltip_controller.js';
import TomSelectController from './tom_select_controller.js';
import TooltipController from './tooltip_controller.js';
import ToggleShowMoreOrLessController from './toggle_show_more_or_less_controller.js';

application.register('address-autocomplete', AddressAutocompleteController);
application.register('add-profile', AddProfileController);
application.register('auto-close-collapse', AutoCloseCollapseController);
application.register('clear-document-file', ClearDocumentFileController);
application.register('conditional-checkboxes', ConditionalCheckboxesController);
application.register('document-type-tabs', DocumentTypeTabsController);
application.register('drag-drop', DragDropController);
application.register('effective-beneficiaries', EffectiveBeneficiariesController);
application.register('intl-tel-input', IntlTelInputController);
application.register('limited-nested-form', LimitedNestedFormController);
application.register('modal', ModalController);
application.register('nested-form', RailsNestedForm);
application.register('pappers-autocomplete', PappersAutocompleteController);
application.register('password-visibility', PasswordVisibilityController);
application.register('profile-steps-preview', ProfileStepsPreviewController);
application.register('start-import', StartImportController);
application.register('tab-switcher', TabSwitcherController);
application.register('table-pagination', TablePaginationController);
application.register('table-tooltip', TableTooltipController);
application.register('tom-select', TomSelectController);
application.register('tooltip', TooltipController);
application.register('toggle-show-more-or-less', ToggleShowMoreOrLessController);
